import { StructuredStorageSlots } from '../../constants';
import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class SetStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapKeyStructuredStorage({
            type: this.keyType,
            knownType: this.knownKeyType,
        }));
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitHelper(node, options, sb.helpers.arrReduce({
            each: (innerOptions) => {
                sb.emitHelper(node, innerOptions, sb.helpers.handlePrefixArrayStructuredStorage);
            },
        }));
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, StructuredStorageSlots.prefix);
        sb.emitOp(node, 'PICKITEM');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, StructuredStorageSlots.prefixArray);
        sb.emitOp(node, 'PICKITEM');
        sb.emitHelper(node, options, sb.helpers.wrapArray);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SWAP');
        sb.emitPushInt(node, 2);
        sb.emitOp(node, 'PACK');
        sb.emitSysCall(node, 'Neo.Runtime.Serialize');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.putStorage);
    }
}

//# sourceMappingURL=SetStructuredStorageHelper.js.map
